import { Button } from "antd";
import styled from "styled-components";

export const StyledHeaderButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) =>
    theme.palette.background.default} !important;
  border-radius: ${({ theme }) => theme.sizes.borderRadius.circle};
  color: ${({ theme }) => theme.palette.text.primary} !important;
  border: 1px dashed ${({ theme }) => theme.palette.borderColor};
  padding: 7px;
  cursor: pointer;
  height: 100%;
`;

export const StyledSidebarCollapseBtn = styled(Button)<{
  collapsed: boolean;
  defaultHide?: boolean;
}>`
  // display: flex;
  display: ${({ defaultHide }) => (defaultHide ? "none" : "flex")};
  position: absolute;
  top: 30px;
  right: -15px;
  z-index: 1000;
  align-items: center;
  justify-content: center;
  border: 1px dashed ${({ theme }) => theme.palette.borderColor};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) =>
    theme.palette.background.default}!important;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 22px;
  padding: 0;
  border-radius: 50%;
  height: auto !important;
  width: auto !important;
  overflow: visible !important;

  transform: ${({ collapsed }) => (collapsed ? "rotate(180deg)" : "none")};
  transition: transform 1s ease;

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.main} !important;
    color: ${({ theme }) => theme.palette.background.default} !important;
  }
`;
